/**
 * Table Component
 *
 * Enhanced table with headers, rows, and optional footer.
 */

import React from 'react';

export interface TableProps {
  headers: string[];
  rows: (string | number)[][];
  footer?: (string | number)[];
  className?: string;
}

export const Table: React.FC<TableProps> = ({ headers, rows, footer, className = '' }) => {
  return (
    <div className={`overflow-x-auto mb-2 ${className}`}>
      <table className="w-full border-collapse text-xs">
        <thead>
          <tr>
            {headers.map((h, i) => (
              <th
                key={i}
                className={`
                  bg-indigo-950 text-indigo-100 px-3 py-2
                  font-semibold whitespace-nowrap
                  ${i === 0 ? 'text-left' : 'text-right'}
                `}
              >
                {h}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((r, i) => (
            <tr key={i} className={i % 2 === 0 ? 'bg-purple-50' : 'bg-white'}>
              {r.map((c, j) => (
                <td
                  key={j}
                  className={`
                    px-3 py-2 border-b border-gray-200
                    ${j === 0 ? 'text-left' : 'text-right font-mono'}
                  `}
                >
                  {c}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
        {footer && (
          <tfoot>
            <tr className="bg-indigo-900">
              {footer.map((c, j) => (
                <td
                  key={j}
                  className={`
                    px-3 py-2 text-indigo-100 font-bold
                    ${j === 0 ? 'text-left' : 'text-right font-mono'}
                  `}
                >
                  {c}
                </td>
              ))}
            </tr>
          </tfoot>
        )}
      </table>
    </div>
  );
};
